module.exports = __webpack_public_path__ + "static/img/OOSH_012.fd47f86.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/OOSH_012.jpg
// module id = hw71
// module chunks = 170